<template>
    <footer id="page_footer" :class=theme>
        <div class="grid-container">
            <div class="grid-x grid-margin-x">
                <router-link to="/about" class="cell auto shrink">О проекте</router-link>
                <router-link to="/poll" class="cell auto shrink">Голосовать за кейс</router-link>
                <social-sharing url="https://criminalcases2020.pravo.ru/" :title="main_page.meta_title" :description="main_page.meta_description" inline-template>
                    <div class="right_side">
                        <network network="facebook" class="social fb">Facebook</network>
                        <network network="vk" class="social vk">ВКонтакте</network>
                        <network network="twitter" class="social tw">Twitter</network>
                        <a href="https://storage.pravo.ru/file/general/3O_2020.pdf" target="_blank" class="pdf">pdf</a>
                    </div>
                </social-sharing>
            </div>
        </div>
    </footer>
</template>

<script>

export default {
    name: "Page_footer",
    data: () => ({
        theme:"light", main_page
    }),
    created(){
        if(this.$route.name != 'index' && this.$route.name != 'slides') this.theme = 'dark'
        this.$root.$on('showOverlay', () => this.theme = 'dark')
        this.$root.$on('hideOverlay', () => this.theme = 'light')
    }
};
</script>

<style lang="scss">
    #page_footer {
        pointer-events:none; background:rgba(0,0,0,.1);
        a, span { pointer-events:all; letter-spacing:1px; }
        .grid-container { transition:filter 1s ease }
        .right_side { display:flex; margin-left:auto; padding-right:6px }
        .social {
            display:flex; margin-left:$space*1.5; background-repeat:no-repeat; background-size:100%; background-position:center bottom; width:22px; height:22px; text-indent:-9999px; cursor:pointer;
            &:focus { outline:none }
            &:first-child { margin-left:0 }
            &.fb { background-image:url("~@/./assets/img/socials_fb.svg") }
            &.vk { background-image:url("~@/./assets/img/socials_vk.svg"); background-position:0 4px }
            &.tw { background-image:url("~@/./assets/img/socials_twitter.svg"); background-position:0 5px; background-size:85%; }
        }
        .pdf { margin-left:$space*1.5; height:20px; display:inline-block; line-height:2.3 }
        
        &.dark {
            background:rgba(255,255,255,.95); z-index:5;
            .grid-container { filter:invert(1) }
        }

        @include small {
            font-size:.6rem!important;
            .social { width:16px; height:18px; }
            a { line-height:2.3; letter-spacing:0; }
        }

        @include medium {
            a { letter-spacing:0; }
        }
    }
</style>